import React from "react";
import "./Header.scss"
import {Avatar} from "@mui/material";
import {Link} from "react-router-dom";


const Header = () => {


    return (

        <div className={"headerContainer"}>
            <div className={"smallImage"}>
                <Link to={'/about'}> <Avatar className={'avatar'}
                                             sx={{width: 42.8, height: 42.8}}
                                             alt="Remy Sharp"
                                             src={'https://i.ibb.co/bm5Cpnp/processed-d6d9e08f-844b-4f93-bcbb-31ac50ad990b-H09-MYp-Ji.jpg'}/></Link>

                <div className={"name"}>Qisen Wang</div>
            </div>
            <div className={"rightInfo"}>
                <Link to={'/about'}>
                    <div className={'about'}>About</div>
                </Link>
                <Link to={'/experience'}>
                    <div className={'about'}>Experience</div>
                </Link>
                <Link to={'/contact'}>
                    <div className={'about'}>Contact</div>
                </Link>
            </div>

        </div>
    )

}


export default Header
